// Calendar Data and State Management
const calendarState = {
    currentDate: new Date(2026, 1, 1), // February 2026
    selectedDate: null,
    selectedTime: null,
    bookingDetails: {
        name: '',
        email: '',
        phone: '',
        notes: ''
    },
    
    // Mock availability data
    availability: {
        // Format: 'YYYY-MM-DD': [available times]
        '2026-02-10': ['9:00 AM', '10:30 AM', '1:00 PM', '2:30 PM', '4:00 PM'],
        '2026-02-11': ['10:00 AM', '11:30 AM', '2:00 PM', '3:30 PM'],
        '2026-02-12': ['9:30 AM', '11:00 AM', '1:30 PM', '3:00 PM', '4:30 PM'],
        '2026-02-13': ['8:30 AM', '10:00 AM', '12:00 PM', '1:30 PM'],
        '2026-02-17': ['9:00 AM', '11:00 AM', '2:00 PM', '4:00 PM'],
        '2026-02-18': ['10:30 AM', '1:00 PM', '3:30 PM'],
        '2026-02-19': ['9:00 AM', '11:30 AM', '2:30 PM', '5:00 PM'],
        '2026-02-20': ['8:00 AM', '10:00 AM', '12:30 PM', '3:00 PM'],
        '2026-02-24': ['9:30 AM', '11:00 AM', '1:00 PM', '4:00 PM'],
        '2026-02-25': ['10:00 AM', '12:00 PM', '2:00 PM', '4:30 PM'],
        '2026-02-26': ['9:00 AM', '1:00 PM', '3:00 PM'],
        '2026-02-27': ['8:30 AM', '11:30 AM', '2:30 PM', '4:00 PM']
    },
    
    // Unavailable dates
    unavailableDates: [
        '2026-02-14', // Valentine's Day
        '2026-02-15', // Weekend
        '2026-02-16', // Weekend
        '2026-02-21', 
        '2026-02-22',
        '2026-02-23'
    ]
};

// DOM Elements
const currentMonthElement = document.getElementById('current-month');
const calendarGridElement = document.getElementById('calendar-grid');
const prevMonthButton = document.getElementById('prev-month');
const nextMonthButton = document.getElementById('next-month');
const timeSelectionElement = document.getElementById('time-selection');
const selectedDateTextElement = document.getElementById('selected-date-text');
const timeSlotsElement = document.getElementById('time-slots');
const bookingFormElement = document.getElementById('booking-form');
const summaryDatetimeElement = document.getElementById('summary-datetime');
const bookingDetailsForm = document.getElementById('booking-details-form');
const backToTimesButton = document.getElementById('back-to-times');
const confirmationModal = document.getElementById('confirmation-modal');
const closeModalButton = document.getElementById('close-modal');
const addToCalendarButton = document.getElementById('add-to-calendar');
const confirmNameElement = document.getElementById('confirm-name');
const confirmDatetimeElement = document.getElementById('confirm-datetime');

// Initialize Calendar
function initCalendar() {
    renderCalendar();
    setupEventListeners();
}

// Render Calendar Grid
function renderCalendar() {
    const year = calendarState.currentDate.getFullYear();
    const month = calendarState.currentDate.getMonth();
    
    // Update month header
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
                        'July', 'August', 'September', 'October', 'November', 'December'];
    currentMonthElement.textContent = `${monthNames[month]} ${year}`;
    
    // Clear existing calendar days (keep headers)
    const existingDays = calendarGridElement.querySelectorAll('.calendar-day');
    existingDays.forEach(day => day.remove());
    
    // Get first day of month and total days
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const totalDays = lastDay.getDate();
    const startingDay = firstDay.getDay(); // 0 = Sunday, 1 = Monday, etc.
    
    // Get today's date for comparison
    const today = new Date();
    const todayString = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}`;
    
    // Add empty cells for days before the first day of the month
    for (let i = 0; i < startingDay; i++) {
        const emptyDay = document.createElement('div');
        emptyDay.className = 'calendar-day empty';
        calendarGridElement.appendChild(emptyDay);
    }
    
    // Add days of the month
    for (let day = 1; day <= totalDays; day++) {
        const date = new Date(year, month, day);
        const dateString = `${year}-${month + 1}-${day}`;
        const formattedDateString = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        
        const dayElement = document.createElement('div');
        dayElement.className = 'calendar-day';
        dayElement.dataset.date = formattedDateString;
        
        // Check if today
        const isToday = dateString === todayString;
        if (isToday) {
            dayElement.classList.add('today');
        }
        
        // Check if past date
        const isPast = date < today && !isToday;
        if (isPast) {
            dayElement.classList.add('past');
        }
        
        // Check if unavailable
        const isUnavailable = calendarState.unavailableDates.includes(formattedDateString);
        if (isUnavailable) {
            dayElement.classList.add('unavailable');
        }
        
        // Check if has availability
        const hasAvailability = calendarState.availability[formattedDateString];
        
        // Day number
        const dayNumberElement = document.createElement('div');
        dayNumberElement.className = 'calendar-day-number';
        dayNumberElement.textContent = day;
        dayElement.appendChild(dayNumberElement);
        
        // Availability indicator
        if (hasAvailability && !isPast && !isUnavailable) {
            const indicatorElement = document.createElement('div');
            indicatorElement.className = 'availability-indicator';
            dayElement.appendChild(indicatorElement);
        }
        
        // Add click event
        if (!isPast && !isUnavailable && hasAvailability) {
            dayElement.addEventListener('click', () => selectDate(formattedDateString, day, month, year));
        }
        
        calendarGridElement.appendChild(dayElement);
    }
}

// Select a date
function selectDate(dateString, day, month, year) {
    // Remove previous selection
    const previouslySelected = document.querySelector('.calendar-day.selected');
    if (previouslySelected) {
        previouslySelected.classList.remove('selected');
    }
    
    // Mark as selected
    const selectedDayElement = document.querySelector(`[data-date="${dateString}"]`);
    selectedDayElement.classList.add('selected');
    
    // Update state
    calendarState.selectedDate = dateString;
    
    // Format date for display
    const dateObj = new Date(year, month, day);
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    const formattedDate = dateObj.toLocaleDateString('en-US', options);
    
    // Update UI
    selectedDateTextElement.textContent = formattedDate;
    timeSelectionElement.classList.add('active');
    bookingFormElement.classList.remove('active');
    
    // Scroll to time selection
    timeSelectionElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    
    // Render time slots
    renderTimeSlots(dateString);
}

// Render time slots for selected date
function renderTimeSlots(dateString) {
    // Clear existing time slots
    timeSlotsElement.innerHTML = '';
    
    // Get available times for this date
    const availableTimes = calendarState.availability[dateString] || [];
    
    if (availableTimes.length === 0) {
        timeSlotsElement.innerHTML = '<p style="grid-column: 1 / -1; text-align: center; color: var(--text-light); padding: 20px;">No available times for this date. Please select another date.</p>';
        return;
    }
    
    // Create time slot elements
    availableTimes.forEach(time => {
        const timeSlotElement = document.createElement('div');
        timeSlotElement.className = 'time-slot';
        timeSlotElement.textContent = time;
        timeSlotElement.dataset.time = time;
        
        timeSlotElement.addEventListener('click', () => selectTime(time, dateString));
        
        timeSlotsElement.appendChild(timeSlotElement);
    });
}

// Select a time slot
function selectTime(time, dateString) {
    // Remove previous selection
    const previouslySelected = document.querySelector('.time-slot.selected');
    if (previouslySelected) {
        previouslySelected.classList.remove('selected');
    }
    
    // Mark as selected
    const selectedTimeElement = document.querySelector(`[data-time="${time}"]`);
    selectedTimeElement.classList.add('selected');
    
    // Update state
    calendarState.selectedTime = time;
    
    // Update summary
    const [month, day, year] = dateString.split('-');
    const dateObj = new Date(year, month - 1, day);
    const weekday = dateObj.toLocaleDateString('en-US', { weekday: 'short' });
    const monthName = dateObj.toLocaleDateString('en-US', { month: 'short' });
    
    summaryDatetimeElement.textContent = `${weekday}, ${monthName} ${parseInt(day)}, ${year} at ${time}`;
    
    // Show booking form
    bookingFormElement.classList.add('active');
    timeSelectionElement.classList.remove('active');
    
    // Scroll to booking form
    bookingFormElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}

// Setup event listeners
function setupEventListeners() {
    // Month navigation
    prevMonthButton.addEventListener('click', () => {
        calendarState.currentDate.setMonth(calendarState.currentDate.getMonth() - 1);
        renderCalendar();
    });
    
    nextMonthButton.addEventListener('click', () => {
        calendarState.currentDate.setMonth(calendarState.currentDate.getMonth() + 1);
        renderCalendar();
    });
    
    // Back to time selection
    backToTimesButton.addEventListener('click', () => {
        bookingFormElement.classList.remove('active');
        timeSelectionElement.classList.add('active');
        timeSelectionElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
    
    // Form submission
    bookingDetailsForm.addEventListener('submit', (e) => {
        e.preventDefault();
        
        // Get form values
        calendarState.bookingDetails.name = document.getElementById('name').value;
        calendarState.bookingDetails.email = document.getElementById('email').value;
        calendarState.bookingDetails.phone = document.getElementById('phone').value;
        calendarState.bookingDetails.notes = document.getElementById('notes').value;
        
        // Update confirmation modal
        confirmNameElement.textContent = calendarState.bookingDetails.name;
        confirmDatetimeElement.textContent = summaryDatetimeElement.textContent;
        
        // Show confirmation modal
        confirmationModal.classList.add('active');
        document.body.style.overflow = 'hidden';
    });
    
    // Modal buttons
    closeModalButton.addEventListener('click', () => {
        confirmationModal.classList.remove('active');
        document.body.style.overflow = 'auto';
        
        // Reset form (in a real app, you might not want to do this)
        bookingDetailsForm.reset();
        bookingFormElement.classList.remove('active');
        
        // Reset selections
        const selectedDay = document.querySelector('.calendar-day.selected');
        if (selectedDay) selectedDay.classList.remove('selected');
        
        const selectedTime = document.querySelector('.time-slot.selected');
        if (selectedTime) selectedTime.classList.remove('selected');
        
        calendarState.selectedDate = null;
        calendarState.selectedTime = null;
        
        // Scroll to top of calendar
        document.querySelector('.calendar-clone-container').scrollIntoView({ behavior: 'smooth' });
    });
    
    addToCalendarButton.addEventListener('click', () => {
        // In a real app, this would generate an .ics file or link to calendar services
        alert('In a production app, this would add the event to your calendar. For now, please check your email for the calendar invitation.');
    });
    
    // Close modal when clicking outside
    confirmationModal.addEventListener('click', (e) => {
        if (e.target === confirmationModal) {
            confirmationModal.classList.remove('active');
            document.body.style.overflow = 'auto';
        }
    });
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', initCalendar);